var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 112,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 112,
    fill: "#fff",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    d: "M8.934 28c.468.052.858.052 1.378.052 2.158 0 4.108-.936 4.108-4.576V9.8h-2.86v13.884c0 1.404-.728 1.742-1.638 1.742-.312 0-.676 0-.988-.026V28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    fillRule: "evenodd",
    d: "M8.863 39.804a3.137 3.137 0 1 1 6.008 1.266 3.137 3.137 0 1 1-1.538 5.693v3.904h-2.666v-3.904a3.137 3.137 0 1 1-1.538-5.693 3.126 3.126 0 0 1-.266-1.266ZM35.294 49.706a4.706 4.706 0 1 1 9.013 1.899A4.706 4.706 0 1 1 42 60.145V66h-4v-5.855a4.706 4.706 0 1 1-2.307-8.54 4.69 4.69 0 0 1-.399-1.9Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    d: "M71.066 84c-.468-.052-.858-.052-1.378-.052-2.158 0-4.108.936-4.108 4.576V102.2h2.86V88.316c0-1.404.728-1.742 1.638-1.742.312 0 .676 0 .988.026V84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    fillRule: "evenodd",
    d: "M71.137 72.196a3.137 3.137 0 1 1-6.008-1.266 3.137 3.137 0 1 1 1.538-5.693v-3.904h2.666v3.904a3.137 3.137 0 1 1 1.538 5.693c.171.387.266.816.266 1.266Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJc);
export default __webpack_public_path__ + "static/media/JC.6c88595e1c3a0a6bb2d450da32546656.svg";
export { ForwardRef as ReactComponent };